export interface ChatbotToolPillProps {
  name: string
  status: 'running' | 'done' | 'error'
  resultSummary?: string
  durationMs?: number
}

export function ChatbotToolPill({ name, status, resultSummary }: ChatbotToolPillProps) {
  const baseClass = 'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium'

  if (status === 'running') {
    return (
      <span className={`${baseClass} bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300`}>
        <span data-testid="pill-spinner" className="inline-block h-2 w-2 animate-pulse rounded-full bg-blue-500" />
        <span>{name}</span>
        <span className="text-blue-400">…</span>
      </span>
    )
  }

  if (status === 'error') {
    return (
      <span className={`${baseClass} bg-red-50 text-red-700 dark:bg-red-900/30 dark:text-red-300`}>
        <span data-testid="pill-error">✕</span>
        <span>{name}</span>
        {resultSummary && <span className="text-red-400">· {resultSummary}</span>}
      </span>
    )
  }

  return (
    <span className={`${baseClass} bg-green-50 text-green-700 dark:bg-green-900/30 dark:text-green-300`}>
      <span data-testid="pill-check">✓</span>
      <span>{name}</span>
      {resultSummary && <span className="text-green-500">· {resultSummary}</span>}
    </span>
  )
}

export default ChatbotToolPill
